import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
// @ts-ignore
import Select from 'react-virtualized-select';
// @ts-ignore
import createFilterOptions from 'react-select-fast-filter-options';

const FilterArea = styled.div`
  width: 90%;

  .notification-filter.Select-control,
  .notification-filter .Select-control {
    background-color: rgba(10, 14, 20, 0.9) !important;
    border: 1px solid rgba(255, 255, 255, 0.12) !important;
    border-radius: 14px !important;
    color: #f8fafc !important;
    height: 46px !important;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03) !important;
  }

  .notification-filter .Select-placeholder,
  .notification-filter .Select--single > .Select-control .Select-value {
    color: rgba(248, 250, 252, 0.9) !important;
    line-height: 44px !important;
    font-size: 14px !important;
  }

  .notification-filter .Select.has-value.Select--single > .Select-control .Select-value .Select-value-label,
  .notification-filter .Select.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value .Select-value-label {
    color: #f1f5f9 !important;
  }

  .notification-filter .Select.is-focused > .Select-control,
  .notification-filter .Select.is-focused:not(.is-open) > .Select-control {
    background-color: rgba(10, 14, 20, 0.98) !important;
    border-color: rgba(52, 211, 153, 0.45) !important;
    box-shadow: 0 0 0 2px rgba(52, 211, 153, 0.18) !important;
  }

  .notification-filter .Select-menu-outer {
    background-color: rgba(6, 10, 15, 0.98) !important;
    border: 1px solid rgba(226, 232, 240, 0.88) !important;
    border-top-color: rgba(226, 232, 240, 0.88) !important;
    border-radius: 0 !important;
    margin-top: 4px !important;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45) !important;
    z-index: 20 !important;
  }

  .notification-filter .Select-option {
    background-color: rgba(6, 10, 15, 0.98) !important;
    color: #f8fafc !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    padding: 10px 14px !important;
  }

  .notification-filter .Select-option.is-selected {
    background-color: rgba(120, 128, 136, 0.78) !important;
    color: #f8fafc !important;
  }

  .notification-filter .Select-option.is-focused {
    background-color: rgba(148, 163, 184, 0.24) !important;
    color: #f8fafc !important;
  }

  .notification-filter .VirtualizedSelectOption,
  .notification-filter .VirtualizedSelectFocusedOption,
  .notification-filter .VirtualizedSelectSelectedOption {
    color: #f8fafc !important;
    opacity: 1 !important;
  }
`;

const Filter: React.FC<{ subscriptionsList: any; setFilterBy: any; filterBy: any }> = (props) => {
  const { subscriptionsList, setFilterBy, filterBy } = props;
  const [subscriptions, setSubscriptions] = useState<any>();
  useEffect(() => {
    if (subscriptionsList && subscriptionsList.length > 0) {
      const list = subscriptionsList.map((src: any) => {
        return {
          label: src.keyword + ' - ' + src.document_source,
          value: src.keyword + '|||' + src.document_source,
        };
      });
      setSubscriptions(list);
    }
  }, [subscriptionsList, setSubscriptions]);

  return (
    <FilterArea>
      <Select
        value={filterBy}
        className="basic-single notification-filter"
        filterOptions={createFilterOptions({ options: subscriptions })}
        name="events"
        options={subscriptions}
        onChange={(e: any) => {
          setFilterBy(e);
        }}
        placeholder="Words/Subjects Tracked"
      />
    </FilterArea>
  );
};
export default Filter;
